module.exports = "/images/empty-counter.png?993489fb3183cdacdcd391debaed8fb6";